<template>
<div id="company">
    <van-search placeholder="请输入需要查询的物流公司名字" v-model="searchKey" show-action>
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="search-result" v-show="companyList.length > 0">
      <van-panel title="查询结果">
        <ul class="company-list">
          <li class="company-item" v-for="item in companyList" :key="item.id">
            <div class="company-info">
              <span class="company-photo"></span>
              <div class="company-detail">
                <p class="company-name">{{item.organName}}<van-rate v-model="item.rating" :count="5" readonly/></p>
                <p class="company-price">
                  <span>价格：{{item.price}}/kg</span>
                </p>
              </div>
            </div>
            <router-link :to="'/search/companyprofile/'+item.id" tag="div" class="company-btn">
              查询详情
            </router-link>
          </li>
        </ul>
      </van-panel>
    </div>
</div>
</template>

<script>
export default {
  name: "Company",
  data() {
    return {
      searchKey: "",
      companyList: []
    };
  },
  methods: {
    onSearch() {
      let params = {
        params: {
          name: this.searchKey
        }
      };
      this.$axios({
        method: "POST",
        url: "merchant/getLogisticsCompanyInfo",
        header: {
          "content-type": "application/json;charset=utf-8"
        },
        data: params
      }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          this.companyList = data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#company {
  .company-list {
    padding: 0 0.25rem 0.25rem;
    .company-item {
      border: 1px solid #ddd;
      margin: 0.25rem 0;
      border-radius: 5px;
      .company-info {
        padding: 0.25rem;
        display: flex;
        .company-photo {
          width: 1.25rem;
          height: 1.25rem;
          display: inline-block;
          background-image: url(../../assets/wuliu1.png);
          background-size: 100%;
          background-repeat: no-repeat;
          border: 1px solid #ddd;
          margin-right: 0.25rem;
        }
        .company-detail {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          font-size: 0.375rem;
          .company-name {
            display: flex;
            color: #666;
          }
          .company-price {
            display: flex;
            justify-content: space-between;
          }
        }
      }
      .company-btn {
        border-top: 1px solid #ddd;
        text-align: center;
        padding: 0.25rem 0;
        color: #666;
      }
    }
  }
}
</style>
